import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { LOCAL_STORAGE_KEYS } from "../global/constant";
import { SharedService } from "./shared.service";

@Injectable({
  providedIn: "root",
})
export class CommonApiService {
  private readonly baseUrl = environment.apiUrl;
  constructor(private http: HttpClient, private sharedService: SharedService) { }

  post<T = any>(url: string, data: any) {
    const companyId = this.sharedService.getCompanyId();
    if (companyId) {
      const headers = new HttpHeaders({
         'company-id': companyId?.toString() || "",
      });
      return this.http.post<T>(this.baseUrl + url, data, { headers });
    } else {
      return this.http.post<T>(this.baseUrl + url, data);
    }
  }

  get<T = any>(
    url: string,
    queryParams?: HttpParams,
    options?: { skipCompanyId?: boolean },
  ) {
    const companyId = options?.skipCompanyId
      ? null
      : this.sharedService.getCompanyId();
    if (companyId) {
      const headers = new HttpHeaders({
        'company-id': companyId?.toString() || "",
      });
      return this.http.get<T>(this.baseUrl + url, {
        params: queryParams,
        headers,
      });
    } else {
      return this.http.get<T>(this.baseUrl + url, {
        params: queryParams,
      });
    }
  }

  update<T = any>(url: string, data: any) {
    const companyId = this.sharedService.getCompanyId();
    if (companyId) {
      const headers = new HttpHeaders({
        'company-id': companyId?.toString() || "",
      });
      return this.http.put<T>(this.baseUrl + url, data, { headers });
    } else {
      return this.http.put<T>(this.baseUrl + url, data);
    }
  }

  delete<T = any>(url: string, queryParams?: HttpParams) {
    return this.http.delete<T>(this.baseUrl + url, {
      params: queryParams,
      headers: {
        company_id: this.sharedService.getCompanyId()?.toString() || "",
      },
    });
  }

  public getParamsFromObj(obj: any): HttpParams {
    let params = new HttpParams();

    if (obj) {
      Object.keys(obj).forEach((key) => {
        if (obj[key] !== "" && obj[key] !== undefined) {
          params = params.set(key, obj[key]);
        }
      });
    }
    return params;
  }

  postBlob(url: string, data: any) {
    const token = localStorage.getItem(LOCAL_STORAGE_KEYS.accessToken);

    return fetch(this.baseUrl + url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify(data),
    });
  }

  getBlob(url: string) {
    const token = localStorage.getItem(LOCAL_STORAGE_KEYS.accessToken);
    return fetch(this.baseUrl + url, {
      method: "get",
      headers: {
        Authorization: "Bearer " + token,
      },
    });
  }
}
